(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["oj-agitate"] && !Shopify.designMode) return;
  try {
    
(function () {
  function hiddenTransform(i) {
    // Mobile stacks the cards, so they rise instead of sliding in from the right.
    if (window.matchMedia('(max-width: 860px)').matches) return 'translateY(24px)';
    return i % 2 === 1 ? 'translateY(18px) translateX(48px)' : 'translateX(48px)';
  }
  function reveal(grid) {
    if (grid.__ojReveal) return; grid.__ojReveal = true;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.oj-agitate__card'));
    if (!cards.length) return;
    cards.forEach(function (card, i) {
      card.style.transitionDelay = (i * 260) + 'ms';
      card.style.opacity = '0';
      card.style.transform = hiddenTransform(i);
    });
    // Clearing transform hands the card back to its CSS resting state.
    function show() { cards.forEach(function (card) { card.style.opacity = '1'; card.style.transform = ''; }); }
    if (!('IntersectionObserver' in window)) { show(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { show(); io.disconnect(); } });
    }, { threshold: 0.25 });
    io.observe(grid);
  }
  function boot() { document.querySelectorAll('[data-oj-agitate-grid]').forEach(reveal); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oj-offer"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(sec) {
    if (sec.__ojOffer) return; sec.__ojOffer = true;
    var main = sec.querySelector('#oj-offer-main-img');
    sec.querySelectorAll('.oj-offer__thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-oj-thumb'); if (src && main) main.src = src;
        sec.querySelectorAll('.oj-offer__thumb').forEach(function (o) { o.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
    var qty = sec.querySelector('[data-oj-qty]');
    if (qty) {
      var input = qty.querySelector('.oj-qty__val');
      qty.querySelector('[data-oj-qty-minus]').addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
      qty.querySelector('[data-oj-qty-plus]').addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; });
    }
    // Add-to-cart is handled by Dawn's <product-form> element (product-form.js):
    // it posts to /cart/add.js, re-renders the cart drawer sections, clears the
    // drawer's is-empty state, and surfaces errors. Same path as the rest of the
    // theme — no bespoke handler here.
  }
  function boot() { document.querySelectorAll('[data-oj-offer]').forEach(init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oj-popup"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.__ojPopupInit) return;
    root.__ojPopupInit = true;
    var d = root.dataset;
    var design = d.design === 'true';
    var key = 'ojpopup:' + (d.campaign || 'default');
    var opened = false;

    function markShown() {
      try {
        if (d.frequency === 'session') sessionStorage.setItem(key, '1');
        else if (d.frequency === 'once') localStorage.setItem(key, 'once');
        else if (d.frequency === 'daily' || d.frequency === 'days') localStorage.setItem(key, String(Date.now()));
      } catch (e) {}
    }
    function alreadyShown() {
      try {
        if (d.frequency === 'every') return false;
        if (d.frequency === 'session') return !!sessionStorage.getItem(key);
        if (d.frequency === 'once') return !!localStorage.getItem(key);
        if (d.frequency === 'daily' || d.frequency === 'days') {
          var t = parseInt(localStorage.getItem(key) || '0', 10);
          if (!t) return false;
          var days = d.frequency === 'daily' ? 1 : (parseInt(d.frequencyDays, 10) || 7);
          return (Date.now() - t) < days * 86400000;
        }
      } catch (e) { return false; }
      return false;
    }
    function open() {
      if (opened) return;
      opened = true;
      root.hidden = false;
      void root.offsetWidth; // force reflow so the CSS transition runs reliably
      root.classList.add('is-open');
      if (d.style === 'modal') document.documentElement.classList.add('oj-popup-lock');
      if (!design) markShown();
      var focusable = root.querySelector('input, button:not([data-oj-popup-close]), a');
      if (focusable) { try { focusable.focus({ preventScroll: true }); } catch (e) {} }
    }
    function close() {
      opened = false;
      root.classList.remove('is-open');
      document.documentElement.classList.remove('oj-popup-lock');
      setTimeout(function () { if (!root.classList.contains('is-open')) root.hidden = true; }, 450);
    }

    root.querySelectorAll('[data-oj-popup-close]').forEach(function (btn) {
      btn.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) close();
    });

    // Copy-to-clipboard for the revealed discount code
    var code = root.querySelector('[data-oj-copy]');
    if (code) {
      var copy = function () {
        var val = code.getAttribute('data-oj-copy');
        if (navigator.clipboard) navigator.clipboard.writeText(val).catch(function () {});
        code.classList.add('is-copied');
      };
      code.addEventListener('click', copy);
      code.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); copy(); } });
    }

    // Theme editor: always preview; react to selecting the section
    if (design) {
      open();
      document.addEventListener('shopify:section:select', function (e) {
        if (e.detail && e.detail.sectionId === d.sectionId) open();
      });
      document.addEventListener('shopify:section:deselect', function (e) {
        if (e.detail && e.detail.sectionId === d.sectionId) close();
      });
      return;
    }

    // Success state after an email signup: open immediately, ignore frequency
    if (root.hasAttribute('data-force-open')) { open(); return; }
    if (alreadyShown()) return;

    var trigger = d.trigger;
    if (trigger === 'immediate') {
      open();
    } else if (trigger === 'delay') {
      setTimeout(open, (parseFloat(d.delay) || 0) * 1000);
    } else if (trigger === 'scroll') {
      var pct = parseFloat(d.scroll) || 40;
      var onScroll = function () {
        var h = document.documentElement.scrollHeight - window.innerHeight;
        if (h > 0 && (window.scrollY / h) * 100 >= pct) { open(); window.removeEventListener('scroll', onScroll); }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    } else if (trigger === 'exit') {
      var onLeave = function (e) {
        if (e.clientY <= 0) { open(); document.removeEventListener('mouseout', onLeave); }
      };
      document.addEventListener('mouseout', onLeave);
      // Exit intent doesn't fire on touch devices — fall back to a 20s timer there
      if ('ontouchstart' in window) setTimeout(function () { if (!opened) open(); }, 20000);
    }
  }

  function boot() {
    var root = document.querySelector('[data-oj-popup]');
    if (root) init(root);
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oj-process"] && !Shopify.designMode) return;
  try {
    
(function () {
  function reveal(list) {
    if (list.__ojReveal) return; list.__ojReveal = true;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var steps = Array.prototype.slice.call(list.querySelectorAll('.oj-lprocess__step'));
    if (!steps.length) return;
    steps.forEach(function (step, i) {
      step.style.transitionDelay = (i * 200) + 'ms';
      step.style.opacity = '0';
      step.style.transform = 'translateY(24px)';
    });
    function show() { steps.forEach(function (step) { step.style.opacity = '1'; step.style.transform = ''; }); }
    if (!('IntersectionObserver' in window)) { show(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { show(); io.disconnect(); } });
    }, { threshold: 0.2 });
    io.observe(list);
  }
  function boot() { document.querySelectorAll('[data-oj-lprocess-steps]').forEach(reveal); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oj-science"] && !Shopify.designMode) return;
  try {
    
(function () {
  function reveal(sec) {
    if (sec.__ojReveal) return; sec.__ojReveal = true;
    sec.classList.add('oj-reveal');
    if (!('IntersectionObserver' in window)) { sec.classList.add('is-visible'); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
    }, { threshold: 0.2 });
    io.observe(sec);
  }
  function boot() { document.querySelectorAll('[data-oj-science]').forEach(reveal); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oj-sticky-buy"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(bar) {
    if (bar.__ojSticky) return; bar.__ojSticky = true;
    var anchorId = bar.getAttribute('data-offer-anchor') || 'offer';
    function onScroll() {
      var offer = document.getElementById(anchorId);
      var past = offer ? (window.scrollY > offer.offsetTop + 200) : (window.scrollY > 3000);
      bar.classList.toggle('is-visible', past);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    var qty = bar.querySelector('[data-oj-qty]');
    if (qty) {
      var input = qty.querySelector('.oj-qty__val');
      qty.querySelector('[data-oj-qty-minus]').addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
      qty.querySelector('[data-oj-qty-plus]').addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; });
    }
    // Add-to-cart runs through Dawn's <product-form> element — same path as the
    // rest of the theme, including cart drawer re-render and error handling.
  }
  function boot() { document.querySelectorAll('[data-oj-sticky-buy]').forEach(init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oj-verse-banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  function reveal(sec) {
    if (sec.__ojReveal) return; sec.__ojReveal = true;
    sec.classList.add('oj-reveal');
    if (!('IntersectionObserver' in window)) { sec.classList.add('is-visible'); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
    }, { threshold: 0.35 });
    io.observe(sec);
  }
  function boot() { document.querySelectorAll('[data-oj-verse]').forEach(reveal); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
